import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Divider,
  Collapse,
  Box,
} from "@mui/material"
import {
  Dashboard as DashboardIcon,
  People as PeopleIcon,
  PersonAdd as PersonAddIcon,
  Work as WorkIcon,
  Group as GroupIcon,
  Search as SearchIcon,
  Assignment as AssignmentIcon,
  AttachMoney as MoneyIcon,
  ExpandLess,
  ExpandMore,
  FiberNew as NewIcon,
  Schedule as ScheduleIcon,
  CheckCircle as CheckCircleIcon,
  Cancel as CancelIcon,
  Receipt as ReceiptIcon,
  Work,
  Receipt,
  Timelapse,
} from "@mui/icons-material"
import { useState } from "react"
import { useNavigate, useLocation } from "react-router-dom"

function Sidebar({ mobileOpen, onMobileClose, drawerWidth, userRole }) {
  const [openProcessing, setOpenProcessing] = useState(false)
  const [openFees, setOpenFees] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const handleProcessingClick = () => {
    setOpenProcessing(!openProcessing)
  }

  const handleFeesClick = () => {
    setOpenFees(!openFees)
  }

  const getMenuItems = () => {
    const commonItems = [{ text: "Dashboard", icon: <DashboardIcon />, path: "/dashboard" },
    ]

    if (userRole === "admin") {
      return [
        ...commonItems,
        { text: "Clients", icon: <PeopleIcon />, path: "/clients" },
        // { text: "Add Client", icon: <PersonAddIcon />, path: "/add-client" },
        { text: "Jobs", icon: <WorkIcon />, path: "/jobs" },
        { text: "Exceeded Due Date", icon: <Timelapse />, path: "/exceeded-due-date-jobs" },
        { text: "Predefined List", icon: <AssignmentIcon />, path: "/predefined-list" },
        { text: "Users", icon: <GroupIcon />, path: "/users" },
        { text: "Receipts", icon:<Receipt /> ,path: "/all-receipts" },
        {
          text: "Fees",
          icon: <MoneyIcon />,
          hasSubmenu: true,
          submenu: [
            { text: "Pending", path: "/fees/pending" },
            { text: "Received", path: "/fees/received" },
          ],
        },
        // { text: "Create User", icon: <PersonAddIcon />, path: "/create-user" },
        { text: "Search Client", icon: <SearchIcon />, path: "/search-client" },
        { text: "Search Jobs", icon: <SearchIcon />, path: "/search-jobs" },
      ]
    }

    if (userRole === "normal") {
      return [
        ...commonItems,
        { text: "New Jobs", icon: <NewIcon />, path: "/new-jobs" },
        {
          text: "Processing Jobs",
          icon: <ScheduleIcon />,
          hasSubmenu: true,
          submenu: [
            { text: "Accepted", path: "/processing/accepted" },
            { text: "Documents Pending", path: "/processing/documents-pending" },
            { text: "Tax Pending", path: "/processing/tax-pending" },
            { text: "Verification Pending", path: "/processing/verification-pending" },
            { text: "Client Not Responding", path: "/processing/client-not-responding" },
            { text: "Kept on Hold", path: "/processing/kept-on-hold" },
          ],
        },
        { text: "Job Completed", icon: <CheckCircleIcon />, path: "/job-completed" },
        { text: "Job Cancelled by Client", icon: <CancelIcon />, path: "/job-cancelled" },
        {
          text: "Fees",
          icon: <MoneyIcon />,
          hasSubmenu: true,
          submenu: [
            { text: "Pending", path: "/fees/pending" },
            { text: "Received", path: "/fees/received" },
          ],
        },
        { text: "Assigned as Secondary", icon:<Work/>, path: "/secondary-jobs"},
        { text: "Search Client", icon: <SearchIcon />, path: "/search-client" },
        { text: "Search Jobs", icon: <SearchIcon />, path: "/search-jobs" },
      ]
    }

    if (userRole === "feesCollector") {
      return [...commonItems, { text: "Add Fee Receipts", icon: <ReceiptIcon />, path: "/add-fee-receipts" },
        { text: "Search Client", icon: <SearchIcon />, path: "/search-client" },
        { text: "Search Jobs", icon: <SearchIcon />, path: "/search-jobs" },
      ]
    }

    if (userRole === "feesSettler") {
      return [...commonItems,
        { text: "Search Client", icon: <SearchIcon />, path: "/search-client" },
        { text: "Search Jobs", icon: <SearchIcon />, path: "/search-jobs" },
      ]
    }

    return commonItems
  }

  const menuItems = getMenuItems()

  const renderMenuItem = (item, index) => {
    if (item.hasSubmenu) {
      const isOpen = item.text === "Processing Jobs" ? openProcessing : openFees
      const handleClick = item.text === "Processing Jobs" ? handleProcessingClick : handleFeesClick

      return (
        <Box key={index}>
          <ListItem disablePadding>
            <ListItemButton onClick={handleClick}>
              <ListItemIcon>{item.icon}</ListItemIcon>
              <ListItemText primary={item.text} />
              {isOpen ? <ExpandLess /> : <ExpandMore />}
            </ListItemButton>
          </ListItem>
          <Collapse in={isOpen} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              {item.submenu.map((subItem, subIndex) => (
                <ListItem key={subIndex} disablePadding>
                  <ListItemButton
                    sx={{ pl: 4 }}
                    selected={location.pathname === subItem.path}
                    onClick={() => {
                      navigate(subItem.path)
                      if (mobileOpen) onMobileClose()
                    }}
                  >
                    <ListItemText primary={subItem.text} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          </Collapse>
        </Box>
      )
    }

    return (
      <ListItem key={index} disablePadding>
        <ListItemButton
          selected={location.pathname === item.path}
          onClick={() => {
            navigate(item.path)
            if (mobileOpen) onMobileClose()
          }}
        >
          <ListItemIcon>{item.icon}</ListItemIcon>
          <ListItemText primary={item.text} />
        </ListItemButton>
      </ListItem>
    )
  }

  const drawer = (
    <div>
      <Toolbar />
      <Divider />
      <List>{menuItems.map((item, index) => renderMenuItem(item, index))}</List>
    </div>
  )

  return (
    <Box component="nav" sx={{ width: { sm: drawerWidth }, flexShrink: { sm: 0 } }}>
      {/* Mobile drawer */}
      <Drawer
        variant="temporary"
        open={mobileOpen}
        onClose={onMobileClose}
        ModalProps={{
          keepMounted: true, // Better open performance on mobile.
        }}
        sx={{
          display: { xs: "block", sm: "none" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
        }}
      >
        {drawer}
      </Drawer>
      {/* Desktop drawer */}
      <Drawer
        variant="permanent"
        sx={{
          display: { xs: "none", sm: "block" },
          "& .MuiDrawer-paper": { boxSizing: "border-box", width: drawerWidth },
        }}
        open
      >
        {drawer}
      </Drawer>
    </Box>
  )
}

export default Sidebar
